export const gameLayers = {
  CrazyWormScene: 'CrazyWormScene',
  ShootSmokeScene: 'ShootSmokeScene',
};
